// Comprehensive emoji dataset organized by category
export interface EmojiItem {
  emoji: string;
  name: string;
  category: string;
}

export const emojiCategories = [
  { id: 'recent', label: '🕐', name: 'Recent' },
  { id: 'smileys', label: '😊', name: 'Smileys' },
  { id: 'people', label: '👋🏾', name: 'People' },
  { id: 'animals', label: '🐶', name: 'Animals' },
  { id: 'food', label: '🍕', name: 'Food' },
  { id: 'travel', label: '✈️', name: 'Travel' },
  { id: 'activities', label: '⚽', name: 'Activities' },
  { id: 'objects', label: '💡', name: 'Objects' },
  { id: 'symbols', label: '❤️', name: 'Symbols' },
  { id: 'flags', label: '🏁', name: 'Flags' },
];

export const emojis: EmojiItem[] = [
  // Smileys
  { emoji: '😀', name: 'grinning face', category: 'smileys' },
  { emoji: '😃', name: 'grinning face with big eyes', category: 'smileys' },
  { emoji: '😄', name: 'grinning face with smiling eyes', category: 'smileys' },
  { emoji: '😁', name: 'beaming face', category: 'smileys' },
  { emoji: '😆', name: 'grinning squinting face', category: 'smileys' },
  { emoji: '😅', name: 'grinning face with sweat', category: 'smileys' },
  { emoji: '🤣', name: 'rolling on the floor laughing', category: 'smileys' },
  { emoji: '😂', name: 'face with tears of joy', category: 'smileys' },
  { emoji: '🙂', name: 'slightly smiling face', category: 'smileys' },
  { emoji: '🙃', name: 'upside down face', category: 'smileys' },
  { emoji: '😉', name: 'winking face', category: 'smileys' },
  { emoji: '😊', name: 'smiling face with smiling eyes', category: 'smileys' },
  { emoji: '😇', name: 'smiling face with halo', category: 'smileys' },
  { emoji: '🥰', name: 'smiling face with hearts', category: 'smileys' },
  { emoji: '😍', name: 'heart eyes', category: 'smileys' },
  { emoji: '🤩', name: 'star struck', category: 'smileys' },
  { emoji: '😘', name: 'face blowing a kiss', category: 'smileys' },
  { emoji: '😗', name: 'kissing face', category: 'smileys' },
  { emoji: '😚', name: 'kissing face with closed eyes', category: 'smileys' },
  { emoji: '😙', name: 'kissing face with smiling eyes', category: 'smileys' },
  { emoji: '🥲', name: 'smiling face with tear', category: 'smileys' },
  { emoji: '😋', name: 'face savoring food', category: 'smileys' },
  { emoji: '😛', name: 'face with tongue', category: 'smileys' },
  { emoji: '😜', name: 'winking face with tongue', category: 'smileys' },
  { emoji: '🤪', name: 'zany face', category: 'smileys' },
  { emoji: '😝', name: 'squinting face with tongue', category: 'smileys' },
  { emoji: '🤑', name: 'money mouth face', category: 'smileys' },
  { emoji: '🤗', name: 'hugging face', category: 'smileys' },
  { emoji: '🤭', name: 'face with hand over mouth', category: 'smileys' },
  { emoji: '🤫', name: 'shushing face', category: 'smileys' },
  { emoji: '🤔', name: 'thinking face', category: 'smileys' },
  { emoji: '🫡', name: 'saluting face', category: 'smileys' },
  { emoji: '🤐', name: 'zipper mouth face', category: 'smileys' },
  { emoji: '🤨', name: 'face with raised eyebrow', category: 'smileys' },
  { emoji: '😐', name: 'neutral face', category: 'smileys' },
  { emoji: '😑', name: 'expressionless face', category: 'smileys' },
  { emoji: '😶', name: 'face without mouth', category: 'smileys' },
  { emoji: '🫥', name: 'dotted line face', category: 'smileys' },
  { emoji: '😏', name: 'smirking face', category: 'smileys' },
  { emoji: '😒', name: 'unamused face', category: 'smileys' },
  { emoji: '🙄', name: 'face with rolling eyes', category: 'smileys' },
  { emoji: '😬', name: 'grimacing face', category: 'smileys' },
  { emoji: '🤥', name: 'lying face', category: 'smileys' },
  { emoji: '😌', name: 'relieved face', category: 'smileys' },
  { emoji: '😔', name: 'pensive face', category: 'smileys' },
  { emoji: '😪', name: 'sleepy face', category: 'smileys' },
  { emoji: '🤤', name: 'drooling face', category: 'smileys' },
  { emoji: '😴', name: 'sleeping face', category: 'smileys' },
  { emoji: '😷', name: 'face with medical mask', category: 'smileys' },
  { emoji: '🤒', name: 'face with thermometer', category: 'smileys' },
  { emoji: '🤕', name: 'face with head bandage', category: 'smileys' },
  { emoji: '🤢', name: 'nauseated face', category: 'smileys' },
  { emoji: '🤮', name: 'face vomiting', category: 'smileys' },
  { emoji: '🥵', name: 'hot face', category: 'smileys' },
  { emoji: '🥶', name: 'cold face', category: 'smileys' },
  { emoji: '🥴', name: 'woozy face', category: 'smileys' },
  { emoji: '😵', name: 'face with crossed out eyes', category: 'smileys' },
  { emoji: '🤯', name: 'exploding head', category: 'smileys' },
  { emoji: '🥳', name: 'partying face', category: 'smileys' },
  { emoji: '🥸', name: 'disguised face', category: 'smileys' },
  { emoji: '😎', name: 'smiling face with sunglasses', category: 'smileys' },
  { emoji: '🤓', name: 'nerd face', category: 'smileys' },
  { emoji: '🧐', name: 'face with monocle', category: 'smileys' },
  { emoji: '😕', name: 'confused face', category: 'smileys' },
  { emoji: '🫤', name: 'face with diagonal mouth', category: 'smileys' },
  { emoji: '😟', name: 'worried face', category: 'smileys' },
  { emoji: '🙁', name: 'slightly frowning face', category: 'smileys' },
  { emoji: '😮', name: 'face with open mouth', category: 'smileys' },
  { emoji: '😯', name: 'hushed face', category: 'smileys' },
  { emoji: '😲', name: 'astonished face', category: 'smileys' },
  { emoji: '😳', name: 'flushed face', category: 'smileys' },
  { emoji: '🥺', name: 'pleading face', category: 'smileys' },
  { emoji: '🥹', name: 'face holding back tears', category: 'smileys' },
  { emoji: '😦', name: 'frowning face with open mouth', category: 'smileys' },
  { emoji: '😧', name: 'anguished face', category: 'smileys' },
  { emoji: '😨', name: 'fearful face', category: 'smileys' },
  { emoji: '😰', name: 'anxious face with sweat', category: 'smileys' },
  { emoji: '😥', name: 'sad but relieved face', category: 'smileys' },
  { emoji: '😢', name: 'crying face', category: 'smileys' },
  { emoji: '😭', name: 'loudly crying face', category: 'smileys' },
  { emoji: '😱', name: 'face screaming in fear', category: 'smileys' },
  { emoji: '😖', name: 'confounded face', category: 'smileys' },
  { emoji: '😣', name: 'persevering face', category: 'smileys' },
  { emoji: '😞', name: 'disappointed face', category: 'smileys' },
  { emoji: '😓', name: 'downcast face with sweat', category: 'smileys' },
  { emoji: '😩', name: 'weary face', category: 'smileys' },
  { emoji: '😫', name: 'tired face', category: 'smileys' },
  { emoji: '🥱', name: 'yawning face', category: 'smileys' },
  { emoji: '😤', name: 'face with steam from nose', category: 'smileys' },
  { emoji: '😡', name: 'pouting face', category: 'smileys' },
  { emoji: '😠', name: 'angry face', category: 'smileys' },
  { emoji: '🤬', name: 'face with symbols on mouth', category: 'smileys' },
  { emoji: '😈', name: 'smiling face with horns', category: 'smileys' },
  { emoji: '👿', name: 'angry face with horns', category: 'smileys' },
  { emoji: '💀', name: 'skull', category: 'smileys' },
  { emoji: '☠️', name: 'skull and crossbones', category: 'smileys' },
  { emoji: '💩', name: 'pile of poo', category: 'smileys' },
  { emoji: '🤡', name: 'clown face', category: 'smileys' },
  { emoji: '👹', name: 'ogre', category: 'smileys' },
  { emoji: '👺', name: 'goblin', category: 'smileys' },
  { emoji: '👻', name: 'ghost', category: 'smileys' },
  { emoji: '👽', name: 'alien', category: 'smileys' },
  { emoji: '👾', name: 'alien monster', category: 'smileys' },
  { emoji: '🤖', name: 'robot', category: 'smileys' },
  { emoji: '🫠', name: 'melting face', category: 'smileys' },
  { emoji: '🫶🏾', name: 'heart hands', category: 'smileys' },

  // People & Gestures
  { emoji: '👋🏾', name: 'waving hand', category: 'people' },
  { emoji: '🤚🏿', name: 'raised back of hand', category: 'people' },
  { emoji: '🖐🏾️', name: 'hand with fingers splayed', category: 'people' },
  { emoji: '✋🏿', name: 'raised hand', category: 'people' },
  { emoji: '🖖🏾', name: 'vulcan salute', category: 'people' },
  { emoji: '🫱🏿', name: 'rightwards hand', category: 'people' },
  { emoji: '🫲🏾', name: 'leftwards hand', category: 'people' },
  { emoji: '🫳🏿', name: 'palm down hand', category: 'people' },
  { emoji: '🫴🏾', name: 'palm up hand', category: 'people' },
  { emoji: '👌🏿', name: 'ok hand', category: 'people' },
  { emoji: '🤌🏾', name: 'pinched fingers', category: 'people' },
  { emoji: '🤏🏿', name: 'pinching hand', category: 'people' },
  { emoji: '✌🏾️', name: 'victory hand', category: 'people' },
  { emoji: '🤞🏿', name: 'crossed fingers', category: 'people' },
  { emoji: '🫰🏾', name: 'hand with index finger and thumb crossed', category: 'people' },
  { emoji: '🤟🏿', name: 'love you gesture', category: 'people' },
  { emoji: '🤘🏾', name: 'sign of the horns', category: 'people' },
  { emoji: '🤙🏿', name: 'call me hand', category: 'people' },
  { emoji: '👈🏾', name: 'backhand index pointing left', category: 'people' },
  { emoji: '👉🏿', name: 'backhand index pointing right', category: 'people' },
  { emoji: '👆🏾', name: 'backhand index pointing up', category: 'people' },
  { emoji: '🖕🏿', name: 'middle finger', category: 'people' },
  { emoji: '👇🏾', name: 'backhand index pointing down', category: 'people' },
  { emoji: '☝🏿️', name: 'index pointing up', category: 'people' },
  { emoji: '🫵🏾', name: 'index pointing at the viewer', category: 'people' },
  { emoji: '👍🏿', name: 'thumbs up', category: 'people' },
  { emoji: '👎🏾', name: 'thumbs down', category: 'people' },
  { emoji: '✊🏿', name: 'raised fist', category: 'people' },
  { emoji: '👊🏾', name: 'oncoming fist', category: 'people' },
  { emoji: '🤛🏿', name: 'left facing fist', category: 'people' },
  { emoji: '🤜🏾', name: 'right facing fist', category: 'people' },
  { emoji: '👏🏿', name: 'clapping hands', category: 'people' },
  { emoji: '🙌🏾', name: 'raising hands', category: 'people' },
  { emoji: '🫶🏿', name: 'heart hands', category: 'people' },
  { emoji: '👐🏾', name: 'open hands', category: 'people' },
  { emoji: '🤲🏿', name: 'palms up together', category: 'people' },
  { emoji: '🤝🏾', name: 'handshake', category: 'people' },
  { emoji: '🙏🏿', name: 'folded hands', category: 'people' },
  { emoji: '✍🏾️', name: 'writing hand', category: 'people' },
  { emoji: '💅🏿', name: 'nail polish', category: 'people' },
  { emoji: '🤳🏾', name: 'selfie', category: 'people' },
  { emoji: '💪🏿', name: 'flexed biceps', category: 'people' },
  { emoji: '🦾', name: 'mechanical arm', category: 'people' },
  { emoji: '🦿', name: 'mechanical leg', category: 'people' },
  { emoji: '🦵🏾', name: 'leg', category: 'people' },
  { emoji: '🦶🏿', name: 'foot', category: 'people' },
  { emoji: '👂🏾', name: 'ear', category: 'people' },
  { emoji: '🦻🏿', name: 'ear with hearing aid', category: 'people' },
  { emoji: '👃🏾', name: 'nose', category: 'people' },
  { emoji: '🧠', name: 'brain', category: 'people' },
  { emoji: '👀', name: 'eyes', category: 'people' },
  { emoji: '👁️', name: 'eye', category: 'people' },
  { emoji: '👅', name: 'tongue', category: 'people' },
  { emoji: '👄', name: 'mouth', category: 'people' },
  { emoji: '🫦', name: 'biting lip', category: 'people' },
  { emoji: '👶🏾', name: 'baby', category: 'people' },
  { emoji: '🧒🏿', name: 'child', category: 'people' },
  { emoji: '👦🏾', name: 'boy', category: 'people' },
  { emoji: '👧🏿', name: 'girl', category: 'people' },
  { emoji: '🧑🏾', name: 'person', category: 'people' },
  { emoji: '👱🏿', name: 'person blond hair', category: 'people' },
  { emoji: '👨🏾', name: 'man', category: 'people' },
  { emoji: '🧔🏿', name: 'person beard', category: 'people' },
  { emoji: '👩🏾', name: 'woman', category: 'people' },
  { emoji: '🧓🏿', name: 'older person', category: 'people' },
  { emoji: '👴🏾', name: 'old man', category: 'people' },
  { emoji: '👵🏿', name: 'old woman', category: 'people' },

  // Animals & Nature
  { emoji: '🐶', name: 'dog face', category: 'animals' },
  { emoji: '🐱', name: 'cat face', category: 'animals' },
  { emoji: '🐭', name: 'mouse face', category: 'animals' },
  { emoji: '🐹', name: 'hamster', category: 'animals' },
  { emoji: '🐰', name: 'rabbit face', category: 'animals' },
  { emoji: '🦊', name: 'fox', category: 'animals' },
  { emoji: '🐻', name: 'bear', category: 'animals' },
  { emoji: '🐼', name: 'panda', category: 'animals' },
  { emoji: '🐨', name: 'koala', category: 'animals' },
  { emoji: '🐯', name: 'tiger face', category: 'animals' },
  { emoji: '🦁', name: 'lion', category: 'animals' },
  { emoji: '🐮', name: 'cow face', category: 'animals' },
  { emoji: '🐷', name: 'pig face', category: 'animals' },
  { emoji: '🐸', name: 'frog', category: 'animals' },
  { emoji: '🐵', name: 'monkey face', category: 'animals' },
  { emoji: '🙈', name: 'see no evil monkey', category: 'animals' },
  { emoji: '🙉', name: 'hear no evil monkey', category: 'animals' },
  { emoji: '🙊', name: 'speak no evil monkey', category: 'animals' },
  { emoji: '🐒', name: 'monkey', category: 'animals' },
  { emoji: '🐔', name: 'chicken', category: 'animals' },
  { emoji: '🐧', name: 'penguin', category: 'animals' },
  { emoji: '🐦', name: 'bird', category: 'animals' },
  { emoji: '🐤', name: 'baby chick', category: 'animals' },
  { emoji: '🐣', name: 'hatching chick', category: 'animals' },
  { emoji: '🦆', name: 'duck', category: 'animals' },
  { emoji: '🦅', name: 'eagle', category: 'animals' },
  { emoji: '🦉', name: 'owl', category: 'animals' },
  { emoji: '🦇', name: 'bat', category: 'animals' },
  { emoji: '🐺', name: 'wolf', category: 'animals' },
  { emoji: '🐗', name: 'boar', category: 'animals' },
  { emoji: '🐴', name: 'horse face', category: 'animals' },
  { emoji: '🦄', name: 'unicorn', category: 'animals' },
  { emoji: '🐝', name: 'honeybee', category: 'animals' },
  { emoji: '🪱', name: 'worm', category: 'animals' },
  { emoji: '🐛', name: 'bug', category: 'animals' },
  { emoji: '🦋', name: 'butterfly', category: 'animals' },
  { emoji: '🐌', name: 'snail', category: 'animals' },
  { emoji: '🐞', name: 'lady beetle', category: 'animals' },
  { emoji: '🐜', name: 'ant', category: 'animals' },
  { emoji: '🪰', name: 'fly', category: 'animals' },
  { emoji: '🐢', name: 'turtle', category: 'animals' },
  { emoji: '🐍', name: 'snake', category: 'animals' },
  { emoji: '🦎', name: 'lizard', category: 'animals' },
  { emoji: '🦂', name: 'scorpion', category: 'animals' },
  { emoji: '🐙', name: 'octopus', category: 'animals' },
  { emoji: '🦑', name: 'squid', category: 'animals' },
  { emoji: '🦐', name: 'shrimp', category: 'animals' },
  { emoji: '🦀', name: 'crab', category: 'animals' },
  { emoji: '🐡', name: 'blowfish', category: 'animals' },
  { emoji: '🐠', name: 'tropical fish', category: 'animals' },
  { emoji: '🐟', name: 'fish', category: 'animals' },
  { emoji: '🐬', name: 'dolphin', category: 'animals' },
  { emoji: '🐳', name: 'spouting whale', category: 'animals' },
  { emoji: '🐋', name: 'whale', category: 'animals' },
  { emoji: '🦈', name: 'shark', category: 'animals' },
  { emoji: '🐊', name: 'crocodile', category: 'animals' },
  { emoji: '🐅', name: 'tiger', category: 'animals' },
  { emoji: '🐆', name: 'leopard', category: 'animals' },
  { emoji: '🦓', name: 'zebra', category: 'animals' },
  { emoji: '🦍', name: 'gorilla', category: 'animals' },
  { emoji: '🦧', name: 'orangutan', category: 'animals' },
  { emoji: '🐘', name: 'elephant', category: 'animals' },
  { emoji: '🦛', name: 'hippopotamus', category: 'animals' },
  { emoji: '🦏', name: 'rhinoceros', category: 'animals' },
  { emoji: '🐪', name: 'camel', category: 'animals' },
  { emoji: '🐫', name: 'two hump camel', category: 'animals' },
  { emoji: '🦒', name: 'giraffe', category: 'animals' },
  { emoji: '🦘', name: 'kangaroo', category: 'animals' },
  { emoji: '🐃', name: 'water buffalo', category: 'animals' },
  { emoji: '🐂', name: 'ox', category: 'animals' },
  { emoji: '🐄', name: 'cow', category: 'animals' },
  { emoji: '🐎', name: 'horse', category: 'animals' },
  { emoji: '🐖', name: 'pig', category: 'animals' },
  { emoji: '🐏', name: 'ram', category: 'animals' },
  { emoji: '🐑', name: 'ewe', category: 'animals' },
  { emoji: '🦙', name: 'llama', category: 'animals' },
  { emoji: '🐐', name: 'goat', category: 'animals' },
  { emoji: '🦌', name: 'deer', category: 'animals' },
  { emoji: '🐕', name: 'dog', category: 'animals' },
  { emoji: '🐩', name: 'poodle', category: 'animals' },
  { emoji: '🐈', name: 'cat', category: 'animals' },
  { emoji: '🦃', name: 'turkey', category: 'animals' },
  { emoji: '🦩', name: 'flamingo', category: 'animals' },
  { emoji: '🕊️', name: 'dove', category: 'animals' },
  { emoji: '🦜', name: 'parrot', category: 'animals' },
  { emoji: '🦢', name: 'swan', category: 'animals' },
  { emoji: '🌸', name: 'cherry blossom', category: 'animals' },
  { emoji: '🌹', name: 'rose', category: 'animals' },
  { emoji: '🌺', name: 'hibiscus', category: 'animals' },
  { emoji: '🌻', name: 'sunflower', category: 'animals' },
  { emoji: '🌼', name: 'blossom', category: 'animals' },
  { emoji: '🌷', name: 'tulip', category: 'animals' },
  { emoji: '🌱', name: 'seedling', category: 'animals' },
  { emoji: '🌲', name: 'evergreen tree', category: 'animals' },
  { emoji: '🌳', name: 'deciduous tree', category: 'animals' },
  { emoji: '🌴', name: 'palm tree', category: 'animals' },
  { emoji: '🌵', name: 'cactus', category: 'animals' },
  { emoji: '🍀', name: 'four leaf clover', category: 'animals' },
  { emoji: '🍁', name: 'maple leaf', category: 'animals' },
  { emoji: '🍂', name: 'fallen leaf', category: 'animals' },
  { emoji: '🍃', name: 'leaf fluttering in wind', category: 'animals' },

  // Food & Drink
  { emoji: '🍇', name: 'grapes', category: 'food' },
  { emoji: '🍈', name: 'melon', category: 'food' },
  { emoji: '🍉', name: 'watermelon', category: 'food' },
  { emoji: '🍊', name: 'tangerine', category: 'food' },
  { emoji: '🍋', name: 'lemon', category: 'food' },
  { emoji: '🍌', name: 'banana', category: 'food' },
  { emoji: '🍍', name: 'pineapple', category: 'food' },
  { emoji: '🥭', name: 'mango', category: 'food' },
  { emoji: '🍎', name: 'red apple', category: 'food' },
  { emoji: '🍏', name: 'green apple', category: 'food' },
  { emoji: '🍐', name: 'pear', category: 'food' },
  { emoji: '🍑', name: 'peach', category: 'food' },
  { emoji: '🍒', name: 'cherries', category: 'food' },
  { emoji: '🍓', name: 'strawberry', category: 'food' },
  { emoji: '🫐', name: 'blueberries', category: 'food' },
  { emoji: '🥝', name: 'kiwi fruit', category: 'food' },
  { emoji: '🍅', name: 'tomato', category: 'food' },
  { emoji: '🫒', name: 'olive', category: 'food' },
  { emoji: '🥥', name: 'coconut', category: 'food' },
  { emoji: '🥑', name: 'avocado', category: 'food' },
  { emoji: '🍆', name: 'eggplant', category: 'food' },
  { emoji: '🥔', name: 'potato', category: 'food' },
  { emoji: '🥕', name: 'carrot', category: 'food' },
  { emoji: '🌽', name: 'ear of corn', category: 'food' },
  { emoji: '🌶️', name: 'hot pepper', category: 'food' },
  { emoji: '🫑', name: 'bell pepper', category: 'food' },
  { emoji: '🥒', name: 'cucumber', category: 'food' },
  { emoji: '🥬', name: 'leafy green', category: 'food' },
  { emoji: '🥦', name: 'broccoli', category: 'food' },
  { emoji: '🧄', name: 'garlic', category: 'food' },
  { emoji: '🧅', name: 'onion', category: 'food' },
  { emoji: '🍄', name: 'mushroom', category: 'food' },
  { emoji: '🥜', name: 'peanuts', category: 'food' },
  { emoji: '🌰', name: 'chestnut', category: 'food' },
  { emoji: '🍞', name: 'bread', category: 'food' },
  { emoji: '🥐', name: 'croissant', category: 'food' },
  { emoji: '🥖', name: 'baguette bread', category: 'food' },
  { emoji: '🫓', name: 'flatbread', category: 'food' },
  { emoji: '🥨', name: 'pretzel', category: 'food' },
  { emoji: '🥯', name: 'bagel', category: 'food' },
  { emoji: '🥞', name: 'pancakes', category: 'food' },
  { emoji: '🧇', name: 'waffle', category: 'food' },
  { emoji: '🧀', name: 'cheese wedge', category: 'food' },
  { emoji: '🍖', name: 'meat on bone', category: 'food' },
  { emoji: '🍗', name: 'poultry leg', category: 'food' },
  { emoji: '🥩', name: 'cut of meat', category: 'food' },
  { emoji: '🥓', name: 'bacon', category: 'food' },
  { emoji: '🍔', name: 'hamburger', category: 'food' },
  { emoji: '🍟', name: 'french fries', category: 'food' },
  { emoji: '🍕', name: 'pizza', category: 'food' },
  { emoji: '🌭', name: 'hot dog', category: 'food' },
  { emoji: '🥪', name: 'sandwich', category: 'food' },
  { emoji: '🌮', name: 'taco', category: 'food' },
  { emoji: '🌯', name: 'burrito', category: 'food' },
  { emoji: '🫔', name: 'tamale', category: 'food' },
  { emoji: '🥗', name: 'green salad', category: 'food' },
  { emoji: '🍝', name: 'spaghetti', category: 'food' },
  { emoji: '🍜', name: 'steaming bowl', category: 'food' },
  { emoji: '🍲', name: 'pot of food', category: 'food' },
  { emoji: '🍛', name: 'curry rice', category: 'food' },
  { emoji: '🍣', name: 'sushi', category: 'food' },
  { emoji: '🍱', name: 'bento box', category: 'food' },
  { emoji: '🥟', name: 'dumpling', category: 'food' },
  { emoji: '🍦', name: 'soft ice cream', category: 'food' },
  { emoji: '🍧', name: 'shaved ice', category: 'food' },
  { emoji: '🍨', name: 'ice cream', category: 'food' },
  { emoji: '🍩', name: 'doughnut', category: 'food' },
  { emoji: '🍪', name: 'cookie', category: 'food' },
  { emoji: '🎂', name: 'birthday cake', category: 'food' },
  { emoji: '🍰', name: 'shortcake', category: 'food' },
  { emoji: '🧁', name: 'cupcake', category: 'food' },
  { emoji: '🥧', name: 'pie', category: 'food' },
  { emoji: '🍫', name: 'chocolate bar', category: 'food' },
  { emoji: '🍬', name: 'candy', category: 'food' },
  { emoji: '🍭', name: 'lollipop', category: 'food' },
  { emoji: '🍮', name: 'custard', category: 'food' },
  { emoji: '🍯', name: 'honey pot', category: 'food' },
  { emoji: '🍼', name: 'baby bottle', category: 'food' },
  { emoji: '☕', name: 'hot beverage', category: 'food' },
  { emoji: '🫖', name: 'teapot', category: 'food' },
  { emoji: '🍵', name: 'teacup', category: 'food' },
  { emoji: '🍶', name: 'sake', category: 'food' },
  { emoji: '🍾', name: 'bottle with popping cork', category: 'food' },
  { emoji: '🍷', name: 'wine glass', category: 'food' },
  { emoji: '🍸', name: 'cocktail glass', category: 'food' },
  { emoji: '🍹', name: 'tropical drink', category: 'food' },
  { emoji: '🍺', name: 'beer mug', category: 'food' },
  { emoji: '🍻', name: 'clinking beer mugs', category: 'food' },
  { emoji: '🥂', name: 'clinking glasses', category: 'food' },
  { emoji: '🥃', name: 'tumbler glass', category: 'food' },
  { emoji: '🧃', name: 'beverage box', category: 'food' },
  { emoji: '🧊', name: 'ice', category: 'food' },

  // Travel & Places
  { emoji: '🌍', name: 'globe europe africa', category: 'travel' },
  { emoji: '🌎', name: 'globe americas', category: 'travel' },
  { emoji: '🌏', name: 'globe asia australia', category: 'travel' },
  { emoji: '🗺️', name: 'world map', category: 'travel' },
  { emoji: '🏔️', name: 'snow capped mountain', category: 'travel' },
  { emoji: '⛰️', name: 'mountain', category: 'travel' },
  { emoji: '🌋', name: 'volcano', category: 'travel' },
  { emoji: '🏕️', name: 'camping', category: 'travel' },
  { emoji: '🏖️', name: 'beach with umbrella', category: 'travel' },
  { emoji: '🏜️', name: 'desert', category: 'travel' },
  { emoji: '🏝️', name: 'desert island', category: 'travel' },
  { emoji: '🏞️', name: 'national park', category: 'travel' },
  { emoji: '🏟️', name: 'stadium', category: 'travel' },
  { emoji: '🏛️', name: 'classical building', category: 'travel' },
  { emoji: '🏗️', name: 'building construction', category: 'travel' },
  { emoji: '🧱', name: 'brick', category: 'travel' },
  { emoji: '🏘️', name: 'houses', category: 'travel' },
  { emoji: '🏠', name: 'house', category: 'travel' },
  { emoji: '🏡', name: 'house with garden', category: 'travel' },
  { emoji: '🏢', name: 'office building', category: 'travel' },
  { emoji: '🏣', name: 'japanese post office', category: 'travel' },
  { emoji: '🏥', name: 'hospital', category: 'travel' },
  { emoji: '🏦', name: 'bank', category: 'travel' },
  { emoji: '🏨', name: 'hotel', category: 'travel' },
  { emoji: '🏩', name: 'love hotel', category: 'travel' },
  { emoji: '🏪', name: 'convenience store', category: 'travel' },
  { emoji: '🏫', name: 'school', category: 'travel' },
  { emoji: '🏬', name: 'department store', category: 'travel' },
  { emoji: '🏭', name: 'factory', category: 'travel' },
  { emoji: '🏯', name: 'japanese castle', category: 'travel' },
  { emoji: '🏰', name: 'castle', category: 'travel' },
  { emoji: '💒', name: 'wedding', category: 'travel' },
  { emoji: '🗼', name: 'tokyo tower', category: 'travel' },
  { emoji: '🗽', name: 'statue of liberty', category: 'travel' },
  { emoji: '⛪', name: 'church', category: 'travel' },
  { emoji: '🕌', name: 'mosque', category: 'travel' },
  { emoji: '🛕', name: 'hindu temple', category: 'travel' },
  { emoji: '🕍', name: 'synagogue', category: 'travel' },
  { emoji: '⛩️', name: 'shinto shrine', category: 'travel' },
  { emoji: '🕋', name: 'kaaba', category: 'travel' },
  { emoji: '⛲', name: 'fountain', category: 'travel' },
  { emoji: '⛺', name: 'tent', category: 'travel' },
  { emoji: '🌁', name: 'foggy', category: 'travel' },
  { emoji: '🌃', name: 'night with stars', category: 'travel' },
  { emoji: '🌄', name: 'sunrise over mountains', category: 'travel' },
  { emoji: '🌅', name: 'sunrise', category: 'travel' },
  { emoji: '🌆', name: 'cityscape at dusk', category: 'travel' },
  { emoji: '🌇', name: 'sunset', category: 'travel' },
  { emoji: '🌉', name: 'bridge at night', category: 'travel' },
  { emoji: '🎠', name: 'carousel horse', category: 'travel' },
  { emoji: '🎡', name: 'ferris wheel', category: 'travel' },
  { emoji: '🎢', name: 'roller coaster', category: 'travel' },
  { emoji: '🚂', name: 'locomotive', category: 'travel' },
  { emoji: '🚃', name: 'railway car', category: 'travel' },
  { emoji: '🚄', name: 'high speed train', category: 'travel' },
  { emoji: '🚅', name: 'bullet train', category: 'travel' },
  { emoji: '🚆', name: 'train', category: 'travel' },
  { emoji: '🚇', name: 'metro', category: 'travel' },
  { emoji: '🚌', name: 'bus', category: 'travel' },
  { emoji: '🚎', name: 'trolleybus', category: 'travel' },
  { emoji: '🚐', name: 'minibus', category: 'travel' },
  { emoji: '🚑', name: 'ambulance', category: 'travel' },
  { emoji: '🚒', name: 'fire engine', category: 'travel' },
  { emoji: '🚓', name: 'police car', category: 'travel' },
  { emoji: '🚕', name: 'taxi', category: 'travel' },
  { emoji: '🚗', name: 'automobile', category: 'travel' },
  { emoji: '🚙', name: 'sport utility vehicle', category: 'travel' },
  { emoji: '🛻', name: 'pickup truck', category: 'travel' },
  { emoji: '🚚', name: 'delivery truck', category: 'travel' },
  { emoji: '🏎️', name: 'racing car', category: 'travel' },
  { emoji: '🏍️', name: 'motorcycle', category: 'travel' },
  { emoji: '🛵', name: 'motor scooter', category: 'travel' },
  { emoji: '🚲', name: 'bicycle', category: 'travel' },
  { emoji: '🛴', name: 'kick scooter', category: 'travel' },
  { emoji: '✈️', name: 'airplane', category: 'travel' },
  { emoji: '🛫', name: 'airplane departure', category: 'travel' },
  { emoji: '🛬', name: 'airplane arriving', category: 'travel' },
  { emoji: '🚀', name: 'rocket', category: 'travel' },
  { emoji: '🛸', name: 'flying saucer', category: 'travel' },
  { emoji: '🚁', name: 'helicopter', category: 'travel' },
  { emoji: '⛵', name: 'sailboat', category: 'travel' },
  { emoji: '🚤', name: 'speedboat', category: 'travel' },
  { emoji: '🛥️', name: 'motor boat', category: 'travel' },
  { emoji: '🚢', name: 'ship', category: 'travel' },
  { emoji: '⚓', name: 'anchor', category: 'travel' },
  { emoji: '🗿', name: 'moai', category: 'travel' },

  // Activities
  { emoji: '⚽', name: 'soccer ball', category: 'activities' },
  { emoji: '🏀', name: 'basketball', category: 'activities' },
  { emoji: '🏈', name: 'american football', category: 'activities' },
  { emoji: '⚾', name: 'baseball', category: 'activities' },
  { emoji: '🥎', name: 'softball', category: 'activities' },
  { emoji: '🎾', name: 'tennis', category: 'activities' },
  { emoji: '🏐', name: 'volleyball', category: 'activities' },
  { emoji: '🏉', name: 'rugby football', category: 'activities' },
  { emoji: '🥏', name: 'flying disc', category: 'activities' },
  { emoji: '🎱', name: 'pool 8 ball', category: 'activities' },
  { emoji: '🪀', name: 'yo yo', category: 'activities' },
  { emoji: '🏓', name: 'ping pong', category: 'activities' },
  { emoji: '🏸', name: 'badminton', category: 'activities' },
  { emoji: '🏒', name: 'ice hockey', category: 'activities' },
  { emoji: '🏑', name: 'field hockey', category: 'activities' },
  { emoji: '🥍', name: 'lacrosse', category: 'activities' },
  { emoji: '🏏', name: 'cricket game', category: 'activities' },
  { emoji: '🪃', name: 'boomerang', category: 'activities' },
  { emoji: '🥅', name: 'goal net', category: 'activities' },
  { emoji: '⛳', name: 'flag in hole', category: 'activities' },
  { emoji: '🪁', name: 'kite', category: 'activities' },
  { emoji: '🏹', name: 'bow and arrow', category: 'activities' },
  { emoji: '🎣', name: 'fishing pole', category: 'activities' },
  { emoji: '🤿', name: 'diving mask', category: 'activities' },
  { emoji: '🥊', name: 'boxing glove', category: 'activities' },
  { emoji: '🥋', name: 'martial arts uniform', category: 'activities' },
  { emoji: '🎽', name: 'running shirt', category: 'activities' },
  { emoji: '⛸️', name: 'ice skate', category: 'activities' },
  { emoji: '🎿', name: 'skis', category: 'activities' },
  { emoji: '🛷', name: 'sled', category: 'activities' },
  { emoji: '🎯', name: 'bullseye', category: 'activities' },
  { emoji: '🪄', name: 'magic wand', category: 'activities' },
  { emoji: '🎮', name: 'video game', category: 'activities' },
  { emoji: '🕹️', name: 'joystick', category: 'activities' },
  { emoji: '🎰', name: 'slot machine', category: 'activities' },
  { emoji: '🎲', name: 'game die', category: 'activities' },
  { emoji: '🧩', name: 'puzzle piece', category: 'activities' },
  { emoji: '🧸', name: 'teddy bear', category: 'activities' },
  { emoji: '🪅', name: 'pinata', category: 'activities' },
  { emoji: '🎭', name: 'performing arts', category: 'activities' },
  { emoji: '🎨', name: 'artist palette', category: 'activities' },
  { emoji: '🎪', name: 'circus tent', category: 'activities' },
  { emoji: '🎤', name: 'microphone', category: 'activities' },
  { emoji: '🎧', name: 'headphone', category: 'activities' },
  { emoji: '🎼', name: 'musical score', category: 'activities' },
  { emoji: '🎵', name: 'musical note', category: 'activities' },
  { emoji: '🎶', name: 'musical notes', category: 'activities' },
  { emoji: '🎷', name: 'saxophone', category: 'activities' },
  { emoji: '🪗', name: 'accordion', category: 'activities' },
  { emoji: '🎸', name: 'guitar', category: 'activities' },
  { emoji: '🎹', name: 'musical keyboard', category: 'activities' },
  { emoji: '🎺', name: 'trumpet', category: 'activities' },
  { emoji: '🎻', name: 'violin', category: 'activities' },
  { emoji: '🪘', name: 'long drum', category: 'activities' },
  { emoji: '🥁', name: 'drum', category: 'activities' },
  { emoji: '🎬', name: 'clapper board', category: 'activities' },
  { emoji: '🎗️', name: 'reminder ribbon', category: 'activities' },
  { emoji: '🏆', name: 'trophy', category: 'activities' },
  { emoji: '🏅', name: 'sports medal', category: 'activities' },
  { emoji: '🥇', name: 'first place medal', category: 'activities' },
  { emoji: '🥈', name: 'second place medal', category: 'activities' },
  { emoji: '🥉', name: 'third place medal', category: 'activities' },
  { emoji: '🎖️', name: 'military medal', category: 'activities' },
  { emoji: '🎪', name: 'circus tent', category: 'activities' },
  { emoji: '🎫', name: 'ticket', category: 'activities' },
  { emoji: '🎟️', name: 'admission tickets', category: 'activities' },
  { emoji: '🎉', name: 'party popper', category: 'activities' },
  { emoji: '🎊', name: 'confetti ball', category: 'activities' },
  { emoji: '🎈', name: 'balloon', category: 'activities' },
  { emoji: '🎀', name: 'ribbon', category: 'activities' },
  { emoji: '🎁', name: 'wrapped gift', category: 'activities' },

  // Objects
  { emoji: '📱', name: 'mobile phone', category: 'objects' },
  { emoji: '📲', name: 'mobile phone with arrow', category: 'objects' },
  { emoji: '💻', name: 'laptop', category: 'objects' },
  { emoji: '⌨️', name: 'keyboard', category: 'objects' },
  { emoji: '🖥️', name: 'desktop computer', category: 'objects' },
  { emoji: '🖨️', name: 'printer', category: 'objects' },
  { emoji: '🖱️', name: 'computer mouse', category: 'objects' },
  { emoji: '💿', name: 'optical disk', category: 'objects' },
  { emoji: '📀', name: 'dvd', category: 'objects' },
  { emoji: '🎥', name: 'movie camera', category: 'objects' },
  { emoji: '📸', name: 'camera with flash', category: 'objects' },
  { emoji: '📹', name: 'video camera', category: 'objects' },
  { emoji: '📺', name: 'television', category: 'objects' },
  { emoji: '📻', name: 'radio', category: 'objects' },
  { emoji: '🧭', name: 'compass', category: 'objects' },
  { emoji: '⏰', name: 'alarm clock', category: 'objects' },
  { emoji: '⌚', name: 'watch', category: 'objects' },
  { emoji: '🔋', name: 'battery', category: 'objects' },
  { emoji: '🔌', name: 'electric plug', category: 'objects' },
  { emoji: '💡', name: 'light bulb', category: 'objects' },
  { emoji: '🔦', name: 'flashlight', category: 'objects' },
  { emoji: '🕯️', name: 'candle', category: 'objects' },
  { emoji: '🪔', name: 'diya lamp', category: 'objects' },
  { emoji: '📔', name: 'notebook', category: 'objects' },
  { emoji: '📕', name: 'closed book', category: 'objects' },
  { emoji: '📖', name: 'open book', category: 'objects' },
  { emoji: '📗', name: 'green book', category: 'objects' },
  { emoji: '📘', name: 'blue book', category: 'objects' },
  { emoji: '📙', name: 'orange book', category: 'objects' },
  { emoji: '📚', name: 'books', category: 'objects' },
  { emoji: '📓', name: 'notebook with decorative cover', category: 'objects' },
  { emoji: '📃', name: 'page with curl', category: 'objects' },
  { emoji: '📄', name: 'page facing up', category: 'objects' },
  { emoji: '📰', name: 'newspaper', category: 'objects' },
  { emoji: '📑', name: 'bookmark tabs', category: 'objects' },
  { emoji: '🔖', name: 'bookmark', category: 'objects' },
  { emoji: '💰', name: 'money bag', category: 'objects' },
  { emoji: '💴', name: 'yen banknote', category: 'objects' },
  { emoji: '💵', name: 'dollar banknote', category: 'objects' },
  { emoji: '💶', name: 'euro banknote', category: 'objects' },
  { emoji: '💷', name: 'pound banknote', category: 'objects' },
  { emoji: '💳', name: 'credit card', category: 'objects' },
  { emoji: '💎', name: 'gem stone', category: 'objects' },
  { emoji: '⚖️', name: 'balance scale', category: 'objects' },
  { emoji: '🔧', name: 'wrench', category: 'objects' },
  { emoji: '🔨', name: 'hammer', category: 'objects' },
  { emoji: '🔩', name: 'nut and bolt', category: 'objects' },
  { emoji: '⚙️', name: 'gear', category: 'objects' },
  { emoji: '🔑', name: 'key', category: 'objects' },
  { emoji: '🗝️', name: 'old key', category: 'objects' },
  { emoji: '🔒', name: 'locked', category: 'objects' },
  { emoji: '🔓', name: 'unlocked', category: 'objects' },
  { emoji: '🧲', name: 'magnet', category: 'objects' },
  { emoji: '💊', name: 'pill', category: 'objects' },
  { emoji: '💉', name: 'syringe', category: 'objects' },
  { emoji: '🩹', name: 'adhesive bandage', category: 'objects' },
  { emoji: '🩺', name: 'stethoscope', category: 'objects' },

  // Symbols
  { emoji: '❤️', name: 'red heart', category: 'symbols' },
  { emoji: '🧡', name: 'orange heart', category: 'symbols' },
  { emoji: '💛', name: 'yellow heart', category: 'symbols' },
  { emoji: '💚', name: 'green heart', category: 'symbols' },
  { emoji: '💙', name: 'blue heart', category: 'symbols' },
  { emoji: '💜', name: 'purple heart', category: 'symbols' },
  { emoji: '🖤', name: 'black heart', category: 'symbols' },
  { emoji: '🤍', name: 'white heart', category: 'symbols' },
  { emoji: '🤎', name: 'brown heart', category: 'symbols' },
  { emoji: '💔', name: 'broken heart', category: 'symbols' },
  { emoji: '❤️‍🔥', name: 'heart on fire', category: 'symbols' },
  { emoji: '❤️‍🩹', name: 'mending heart', category: 'symbols' },
  { emoji: '❣️', name: 'heart exclamation', category: 'symbols' },
  { emoji: '💕', name: 'two hearts', category: 'symbols' },
  { emoji: '💞', name: 'revolving hearts', category: 'symbols' },
  { emoji: '💓', name: 'beating heart', category: 'symbols' },
  { emoji: '💗', name: 'growing heart', category: 'symbols' },
  { emoji: '💖', name: 'sparkling heart', category: 'symbols' },
  { emoji: '💘', name: 'heart with arrow', category: 'symbols' },
  { emoji: '💝', name: 'heart with ribbon', category: 'symbols' },
  { emoji: '💟', name: 'heart decoration', category: 'symbols' },
  { emoji: '☮️', name: 'peace symbol', category: 'symbols' },
  { emoji: '✝️', name: 'latin cross', category: 'symbols' },
  { emoji: '☪️', name: 'star and crescent', category: 'symbols' },
  { emoji: '🕉️', name: 'om', category: 'symbols' },
  { emoji: '☯️', name: 'yin yang', category: 'symbols' },
  { emoji: '✡️', name: 'star of david', category: 'symbols' },
  { emoji: '♈', name: 'aries', category: 'symbols' },
  { emoji: '♉', name: 'taurus', category: 'symbols' },
  { emoji: '♊', name: 'gemini', category: 'symbols' },
  { emoji: '♋', name: 'cancer', category: 'symbols' },
  { emoji: '♌', name: 'leo', category: 'symbols' },
  { emoji: '♍', name: 'virgo', category: 'symbols' },
  { emoji: '♎', name: 'libra', category: 'symbols' },
  { emoji: '♏', name: 'scorpio', category: 'symbols' },
  { emoji: '♐', name: 'sagittarius', category: 'symbols' },
  { emoji: '♑', name: 'capricorn', category: 'symbols' },
  { emoji: '♒', name: 'aquarius', category: 'symbols' },
  { emoji: '♓', name: 'pisces', category: 'symbols' },
  { emoji: '⛎', name: 'ophiuchus', category: 'symbols' },
  { emoji: '🔴', name: 'red circle', category: 'symbols' },
  { emoji: '🟠', name: 'orange circle', category: 'symbols' },
  { emoji: '🟡', name: 'yellow circle', category: 'symbols' },
  { emoji: '🟢', name: 'green circle', category: 'symbols' },
  { emoji: '🔵', name: 'blue circle', category: 'symbols' },
  { emoji: '🟣', name: 'purple circle', category: 'symbols' },
  { emoji: '🟤', name: 'brown circle', category: 'symbols' },
  { emoji: '⚫', name: 'black circle', category: 'symbols' },
  { emoji: '⚪', name: 'white circle', category: 'symbols' },
  { emoji: '🔶', name: 'large orange diamond', category: 'symbols' },
  { emoji: '🔷', name: 'large blue diamond', category: 'symbols' },
  { emoji: '🔸', name: 'small orange diamond', category: 'symbols' },
  { emoji: '🔹', name: 'small blue diamond', category: 'symbols' },
  { emoji: '🔺', name: 'red triangle pointed up', category: 'symbols' },
  { emoji: '🔻', name: 'red triangle pointed down', category: 'symbols' },
  { emoji: '💠', name: 'diamond with a dot', category: 'symbols' },
  { emoji: '🔘', name: 'radio button', category: 'symbols' },
  { emoji: '🔲', name: 'black square button', category: 'symbols' },
  { emoji: '🔳', name: 'white square button', category: 'symbols' },
  { emoji: '✅', name: 'check mark button', category: 'symbols' },
  { emoji: '☑️', name: 'check box with check', category: 'symbols' },
  { emoji: '✔️', name: 'check mark', category: 'symbols' },
  { emoji: '❌', name: 'cross mark', category: 'symbols' },
  { emoji: '❎', name: 'cross mark button', category: 'symbols' },
  { emoji: '➕', name: 'plus', category: 'symbols' },
  { emoji: '➖', name: 'minus', category: 'symbols' },
  { emoji: '➗', name: 'divide', category: 'symbols' },
  { emoji: '✖️', name: 'multiply', category: 'symbols' },
  { emoji: '♾️', name: 'infinity', category: 'symbols' },
  { emoji: '‼️', name: 'double exclamation mark', category: 'symbols' },
  { emoji: '⁉️', name: 'exclamation question mark', category: 'symbols' },
  { emoji: '❓', name: 'red question mark', category: 'symbols' },
  { emoji: '❔', name: 'white question mark', category: 'symbols' },
  { emoji: '❕', name: 'white exclamation mark', category: 'symbols' },
  { emoji: '❗', name: 'red exclamation mark', category: 'symbols' },
  { emoji: '💯', name: 'hundred points', category: 'symbols' },
  { emoji: '🔥', name: 'fire', category: 'symbols' },
  { emoji: '💫', name: 'dizzy', category: 'symbols' },
  { emoji: '⭐', name: 'star', category: 'symbols' },
  { emoji: '🌟', name: 'glowing star', category: 'symbols' },
  { emoji: '✨', name: 'sparkles', category: 'symbols' },
  { emoji: '💥', name: 'collision', category: 'symbols' },
  { emoji: '💢', name: 'anger symbol', category: 'symbols' },
  { emoji: '💤', name: 'zzz', category: 'symbols' },
  { emoji: '💬', name: 'speech balloon', category: 'symbols' },
  { emoji: '👁️‍🗨️', name: 'eye in speech bubble', category: 'symbols' },
  { emoji: '🗯️', name: 'right anger bubble', category: 'symbols' },
  { emoji: '💭', name: 'thought balloon', category: 'symbols' },
  { emoji: '🕳️', name: 'hole', category: 'symbols' },

  // Flags
  { emoji: '🏁', name: 'chequered flag', category: 'flags' },
  { emoji: '🚩', name: 'triangular flag', category: 'flags' },
  { emoji: '🎌', name: 'crossed flags', category: 'flags' },
  { emoji: '🏴', name: 'black flag', category: 'flags' },
  { emoji: '🏳️', name: 'white flag', category: 'flags' },
  { emoji: '🏳️‍🌈', name: 'rainbow flag', category: 'flags' },
  { emoji: '🏳️‍⚧️', name: 'transgender flag', category: 'flags' },
  { emoji: '🇦🇺', name: 'flag australia', category: 'flags' },
  { emoji: '🇦🇹', name: 'flag austria', category: 'flags' },
  { emoji: '🇧🇷', name: 'flag brazil', category: 'flags' },
  { emoji: '🇨🇦', name: 'flag canada', category: 'flags' },
  { emoji: '🇨🇳', name: 'flag china', category: 'flags' },
  { emoji: '🇫🇷', name: 'flag france', category: 'flags' },
  { emoji: '🇩🇪', name: 'flag germany', category: 'flags' },
  { emoji: '🇮🇳', name: 'flag india', category: 'flags' },
  { emoji: '🇮🇩', name: 'flag indonesia', category: 'flags' },
  { emoji: '🇮🇹', name: 'flag italy', category: 'flags' },
  { emoji: '🇯🇵', name: 'flag japan', category: 'flags' },
  { emoji: '🇰🇷', name: 'flag south korea', category: 'flags' },
  { emoji: '🇲🇽', name: 'flag mexico', category: 'flags' },
  { emoji: '🇳🇿', name: 'flag new zealand', category: 'flags' },
  { emoji: '🇳🇬', name: 'flag nigeria', category: 'flags' },
  { emoji: '🇵🇭', name: 'flag philippines', category: 'flags' },
  { emoji: '🇷🇺', name: 'flag russia', category: 'flags' },
  { emoji: '🇸🇦', name: 'flag saudi arabia', category: 'flags' },
  { emoji: '🇸🇬', name: 'flag singapore', category: 'flags' },
  { emoji: '🇿🇦', name: 'flag south africa', category: 'flags' },
  { emoji: '🇪🇸', name: 'flag spain', category: 'flags' },
  { emoji: '🇸🇪', name: 'flag sweden', category: 'flags' },
  { emoji: '🇨🇭', name: 'flag switzerland', category: 'flags' },
  { emoji: '🇹🇭', name: 'flag thailand', category: 'flags' },
  { emoji: '🇹🇷', name: 'flag turkey', category: 'flags' },
  { emoji: '🇦🇪', name: 'flag uae', category: 'flags' },
  { emoji: '🇬🇧', name: 'flag united kingdom', category: 'flags' },
  { emoji: '🇺🇸', name: 'flag united states', category: 'flags' },
  { emoji: '🇻🇳', name: 'flag vietnam', category: 'flags' },
];
